import { useState } from 'react';
import { motion } from 'framer-motion';
import { NEONVERSE } from '../constants';

const NeonFAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="nv-section" id="faq">
      <div className="nv-container" style={{ maxWidth: 760 }}>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.55 }}
        >
          <p className="nv-eyebrow">FAQ</p>
          <h2 className="nv-title">Frequently Asked Questions</h2>
          <div className="nv-faq__list">
            {NEONVERSE.faqs.map((faq, i) => {
              const open = openIndex === i;
              return (
                <div key={faq.q} className={`nv-faq__item${open ? ' open' : ''}`}>
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenIndex(open ? null : i)}
                  >
                    {faq.q}
                    <span className="nv-faq__icon" aria-hidden="true" />
                  </button>
                  <div className="nv-faq__answer">
                    <p>{faq.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default NeonFAQ;
